import React from 'react';
import './selectedCriterion.css';

const SelectedCriterion = (props) => {
  const labelStyle = {
    fontSize: '0.8rem',
    lineHeight: '1rem',
    fontWeight: '600',
    margin: '0'
  }
  const wrapperStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr'
  }
  const preferenceLabelStyle = {
    fontSize: '0.6rem',
    opacity: '0.6',
    margin: '0 8px 0 0'
  }
  let updateAttribute = (type, value) =>
    props.updateAttribute(type, props.criterion, props.step, parseInt(value, 10))
  let handleOnBlur = (type) => {
    if (props.criterion.min <= props.criterion.max) return;
    switch(type) {
      case "max":
        updateAttribute(type, props.criterion.min);
        return;
      case "min":
        updateAttribute(type, props.criterion.max);
        return;
      default:
        console.error("unknown `handleOnBlur` type");
    }
  }

  let rangeSelector = () =>
    <div style={wrapperStyle}>
      <div>
        <label style={preferenceLabelStyle}>Min</label>
        <input
          onChange={(e) => updateAttribute("min", e.target.value)}
          onBlur={() => handleOnBlur("min")}
          className="font-color-dark"
          type="number" value={props.criterion.min}/>
      </div>
      <div>
        <label style={preferenceLabelStyle}>Max</label>
        <input
          onChange={(e) => updateAttribute("max", e.target.value)}
          onBlur={() => handleOnBlur("max")}
          className="font-color-dark"
          type="number" value={props.criterion.max}/>
      </div>
    </div>;

  let sortingOrderSelector = () =>
    <div>
      <label
        className="labelStyle"
        onClick={() => props.valueOnUpdate("sortType", "Smallest")}
      >
        <div className="radioContainer">
          <input
            type="radio"
            value="Smallest"
            checked={props.sortType==='Smallest'}
          />
        </div>
        Smallest First
      </label>
      <label
        className="labelStyle"
        onClick={() => props.valueOnUpdate("sortType", "Largest")}
      >
        <div className="radioContainer">
          <input
            type="radio"
            value="Largest"
            checked={props.sortType==='Largest'}
          />
        </div>
        Largest First
      </label>
    </div>;

  return (
    <div
      className="selectedCriteria padding-left-right-md border-top"
      onClick={() => props.clicked(props.criterion.label, props.step)}>
      <div className="selectedHeader">
        <p className="font-color-dark" style={labelStyle}>{props.criterion.label}</p>
        <i onClick={() => props.remove(props.criterion, props.step)} className="material-icons close font-color-dark">close</i>
      </div>
      { props.step<2 ? rangeSelector() : sortingOrderSelector() }
    </div>
  )
}

export default SelectedCriterion;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/sidebar/SelectedCriterion.js